import React from "react";
import { string, arrayOf, shape, bool } from "prop-types";
import { Link } from "@quintype/components";

import { STATIC_KEYWORDS } from "../../../constants";
import { getTemplateName } from "../../utils";
import { getCategoryAndSubCategory } from "../../../ga-utils";
import get from "lodash/get";

import "./NavSubMenu.m.css";
import { useSelector } from "react-redux";

const NavSubMenu = ({ subMenuitems, customStyleName, isActive, parentMenuName, story, config, pageType }) => {
  let subMenuItemCount = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "submenu-item-count"], 6));
  /* restrict Limit sub menu item count to 6 */
  if (subMenuItemCount > 6) {
    subMenuItemCount = 6;
  }
  const { MENU_ITEM } = STATIC_KEYWORDS;
  const menuColumns = [];
  for (let i = 0; i < subMenuitems.length; i += subMenuItemCount) {
    menuColumns.push(subMenuitems.slice(i, i + subMenuItemCount));
  }
  const columnClass =
  menuColumns.length === 2
    ? "twocolbox"
    : menuColumns.length === 3
    ? "threecolbox"
    : menuColumns.length === 4
    ? "fourcolbox"
    : menuColumns.length === 5
    ? "fivecolbox"
    : menuColumns.length === 6
    ? "sixcolbox"
    : "";
  return (
    <div
      styleName={`sub-menu-wrapper ${columnClass} ${customStyleName} ${
        isActive ? "active" : "inactive"
      }`}
    >
      {menuColumns.map((menuItems, columnIndex) => (
        <ul className="sub-menu" styleName="sub-menu" key={columnIndex}>
          {menuItems.map(({ completeUrl, title }, index) => {
            const handleSubMenuClick = (e) => {
              e.preventDefault();
              e.stopPropagation();

              window.dataLayer = window.dataLayer || [];

              const categoryInfo = getCategoryAndSubCategory(
                window.location,
                pageType,
                config,
                story
              );

              window.dataLayer.push({
                event: "dl_menu_click",
                link_url: completeUrl || "#",
                link_text: title.toLowerCase(),
                link_category: parentMenuName.toLowerCase(),
                category: categoryInfo.category,
                sub_category: categoryInfo.subCategory,
                content_id: categoryInfo.contentId,
                template_name: getTemplateName(
                  story?.["story-template"] || pageType
                ),
                platform: window.innerWidth >= 768 ? "desktop" : "mobile",
                eventCallback: function () {
                  window.location.href = completeUrl || "#";
                },
              });
            };

            return (
              <li
                styleName="sub-item"
                key={`${title}-${columnIndex}-${index}`}
              >
                <div onClick={handleSubMenuClick} style={{ display: "contents" }}>
                  <Link
                    href={completeUrl || "#"}
                    className="link"
                    disableAjaxLinks={true}
                  >
                    {title || MENU_ITEM}
                  </Link>
                </div>
              </li>
            );
          })}
        </ul>
      ))}
    </div>
  );
};

NavSubMenu.defaultProps = {
  subMenuitems: [],
  customStyleName: "",
  parentMenuName: "",
};

NavSubMenu.propTypes = {
  subMenuitems: arrayOf(
    shape({
      completeUrl: string,
      title: string,
    })
  ).isRequired,
  customStyleName: string,
  isActive: bool,
  parentMenuName: string,
};

export default NavSubMenu;
